import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面未找到 - 蜜桃成熟时3D",
    description: "抱歉，你访问的页面不存在或已被移除。请返回首页，继续浏览蜜桃成熟时3D的影视资讯。",
    keywords: "页面未找到,蜜桃成熟时3D",
    path: "/",
  });

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center px-4 text-center md:px-6">
        <span className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-primary-600">
          <i className="ri-movie-2-line text-4xl"></i>
        </span>
        <p className="font-heading text-5xl font-bold text-primary-600 md:text-6xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
          抱歉，你访问的页面不存在或已被移除。不如回到首页，继续浏览「蜜桃成熟时3D」的影视资讯吧。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/news"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            浏览最新资讯
          </Link>
        </div>
      </div>
    </section>
  );
}